import { useMutation } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';
import { withDateRange } from '@/helpers/dateRangeFilename';

// Downloads a CSV of per-matter usage stats (pages, runs, chronologies, Kim threads)
// for every matter in the org, scoped to the given date range.
export const useDownloadMatterStats = () => {
  const { getFetchConfig } = useGetFetchConfig();

  const downloadMatterStats = async ({
    organisationId,
    startDate,
    endDate,
  }: {
    organisationId: string;
    startDate?: Date;
    endDate?: Date;
  }) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.POST,
      data: { organisationId, startDate, endDate },
    });

    const response = await fetch(`${APIBaseChronos}/api/usage/matter-stats/download`, fetchConfig);
    if (!response.ok) {
      throw new Error('Failed to download matter stats');
    }

    const blob = await response.blob();
    const link = Object.assign(document.createElement('a'), {
      href: URL.createObjectURL(blob),
      download: withDateRange('matter-usage-stats', 'csv', startDate, endDate),
    });
    link.click();
    URL.revokeObjectURL(link.href);
  };

  const { mutate: fetchDownload, isLoading } = useMutation(downloadMatterStats, {
    onError: () => {
      toast.error('Failed to download matter stats. Please try again.');
    },
  });

  return { fetchDownload, isLoading };
};
